import { type ComponentProps } from 'react'
import { Dialog as BaseDialog } from '@base-ui/react/dialog'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface DialogDescriptionProps extends PartProps<ComponentProps<typeof BaseDialog.Description>> {
  className?: string
}

export function DialogDescription({ className, children, ...props }: DialogDescriptionProps) {
  return (
    <BaseDialog.Description className={twMerge('text-foreground-secondary text-md', className)} {...props}>
      {children}
    </BaseDialog.Description>
  )
}
